import CardFrontEdit from '~/components/CardMaker/components/CardFrontEdit';
import CardText from '~/components/CardMaker/components/CardFrontEdit/CardText';
import CardArt from '~/components/CardMaker/components/CardFrontEdit/CardArt';

export function renderCardFrontEdit({ name, replacements, hasTitle = true }) {
    return (tempUrl, setTempUrl, convertedContent, nameColor, frontSides) => {

        return (
            <CardFrontEdit
                cardFrame={tempUrl.cardFrame}
                id={frontSides.find((item) => item.includes('.')) || 'cardFrame'}
                replacements={replacements}
                cardArtElement={<CardArt cardArt={tempUrl.cardArt} />}
                cardTextElement={
                    <CardText
                        title={name}
                        description={convertedContent}
                        nameColor={nameColor}
                        hasTitle={hasTitle}
                    />
                }
            />
        );
    };
}
